import { useAppSelector } from 'common/hooks/redux'

import { MetabaseDashboard } from './MetabaseDashboard'

export const MetabaseCampaignOverview = () => {
  const dashboardId = process.env.REACT_APP_METABASE_CAMPAIGN_DASHBOARD_ID

  const campaignId = useAppSelector(
    (state) => state.campaignStates?.campaignData?._id
  )

  if (!dashboardId) {
    // eslint-disable-next-line no-console
    console.error('Dashboard ID not configured')
    return (
      <div className="flex h-full items-center justify-center p-10">
        <div className="rounded bg-coolGray-50 p-6 text-base-700">
          Unable to load campaign overview. Please contact support.
        </div>
      </div>
    )
  }

  const additionalParams = campaignId
    ? { campaign_name: campaignId }
    : undefined

  return (
    <MetabaseDashboard
      dashboardId={dashboardId}
      additionalParams={additionalParams}
    />
  )
}
